import React, { useEffect, useState } from 'react';

const generateRandomNumber = () => {
  return Math.floor(Math.random() * 90) + 10; // 10から99までのランダムな数
};

const CalculationPage = ({ onTimeUp }) => {
  const [timeLeft, setTimeLeft] = useState(1);
  const [correctCount, setCorrectCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [num1, setNum1] = useState(generateRandomNumber());
  const [num2, setNum2] = useState(generateRandomNumber());
  const [answer, setAnswer] = useState('');

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          onTimeUp(correctCount, totalCount);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [correctCount, totalCount, onTimeUp]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const correctAnswer = num1 + num2;
    setTotalCount((prevCount) => prevCount + 1);
    if (parseInt(answer) === correctAnswer) {
      setCorrectCount((prevCount) => prevCount + 1);
    }
    setNum1(generateRandomNumber());
    setNum2(generateRandomNumber());
    setAnswer('');
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-violet-200">
      <h1 className="text-2xl mb-4">Calculation Page</h1>
      <p className="mb-4">Time Left: {timeLeft}s</p>
      <form onSubmit={handleSubmit} className="mb-4">
        <div className="mb-4">
          <span className="text-xl">{num1} + {num2} = </span>
          <input
            type="number"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            className="border rounded p-1 text-xl"
            required
          />
        </div>
        <button type="submit" className="p-2 bg-blue-500 text-white rounded">
          Submit Answer
        </button>
      </form>
      <p className="mt-4">Correct Answers: {correctCount}</p>
      <p>Total Calculations: {totalCount}</p>
    </div>
  );
};

export default CalculationPage;
